import { Component, OnInit } from '@angular/core';
import { ModalController, ModalOptions, PopoverController } from '@ionic/angular';
import { AHSTripettoComponent } from '@nx-ahs/script-collector';
import { ConfirmModalComponent } from '../../confirm-modal/confirm-modal/confirm-modal.component';

@Component({
	selector: 'nx-ahs-button-open-component-modal',
	templateUrl: './button-open-component-modal.component.html',
	styleUrls: ['./button-open-component-modal.component.scss'],
	standalone: false
})
export class ButtonOpenComponentModalComponent extends AHSTripettoComponent implements OnInit {
	public buttonText: string;
	public componentObj: ModalOptions;
	public useConfirmIfHasData = false;
	public confirmTitle = 'Warning';
	public confirmMessage = 'Your selected results will be lost. Continue?';
	public confirmYesText = 'Yes';
	public confirmNoText = 'No';

	constructor(
		private modalController: ModalController,
		private popoverController: PopoverController
	) {
		super();
	}

	ngOnInit(): void {}

	public async clickButton() {
		let confirmModalData = undefined;

		if (this.useConfirmIfHasData) {
			const confirmModal = await this.popoverController.create({
				backdropDismiss: false,
				component: ConfirmModalComponent,
				mode: 'ios',
				componentProps: {
					title: this.confirmTitle,
					message: this.confirmMessage,
					justOK: false,
					yesText: this.confirmYesText,
					noText: this.confirmNoText,
					messageIsHTML: true
				},
				cssClass: 'acct-confirm-popover'
			});

			if (this.getTripettoValue()) {
				await confirmModal.present();
				confirmModalData = await confirmModal.onWillDismiss();
			}
		}

		if (!confirmModalData || confirmModalData?.data) {
			const modal = await this.modalController.create(this.componentObj);

			await modal.present();

			const modalData = await modal.onWillDismiss();

			if (modalData?.data?.length) {
				this.setTripettoValue(null);
				setTimeout(() => {
					this.setTripettoValue(modalData?.data);
				});
			}
		}
	}
}
